export const getPathSegments = (pathname) => {
  return pathname?.split('/').filter(Boolean)
}

export const getSecondLastSegment = (pathSegments) => {
  return pathSegments?.[pathSegments.length - 2]?.replace(/-/g, ' ')
}

export const generateNewPath = (pathname) => {
  const pathSegments = getPathSegments(pathname)
  if (pathSegments.length <= 1) return '/'
  // Remove the last segment to navigate to the parent route (preserving full path prefixes like /c/ /s/)
  return '/' + pathSegments.slice(0, -1).join('/')
}
